import { InPlayFilters } from 'constants/inPlay';

export const getTab = (filter: string | undefined, inPlayDefTabHighlights: boolean) => {
  if (filter === undefined) {
    return inPlayDefTabHighlights ? InPlayFilters.HIGHLIGHTS : InPlayFilters.NOW;
  }

  return filter === InPlayFilters.HIGHLIGHTS ? InPlayFilters.HIGHLIGHTS : InPlayFilters.NOW;
};
